import { render, staticRenderFns } from "./hzItemDetailsPop.vue?vue&type=template&id=38b6c171&scoped=true&"
import script from "./hzItemDetailsPop.vue?vue&type=script&lang=js&"
export * from "./hzItemDetailsPop.vue?vue&type=script&lang=js&"
import style0 from "./hzItemDetailsPop.vue?vue&type=style&index=0&id=38b6c171&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b6c171",
  null
  
)

export default component.exports